import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Search, Share2, MousePointerClick, FileText, Palette, 
  TrendingUp, Globe, Video, BarChart3, Brain, Shield, ArrowRight, CreditCard, ExternalLink
} from 'lucide-react';
import { services } from '../data/mock';
import { DIGITAL_CARD_URL } from '../data/servicesData';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';

const iconMap = {
  Search, Share2, MousePointerClick, FileText, Palette,
  TrendingUp, Globe, Video, BarChart3, Brain, Shield
};

const Services = () => {
  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 
            className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4"
            style={{ fontFamily: 'var(--font-serif)' }}
          >
            Comprehensive Digital Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From strategy to execution, we provide end-to-end digital solutions that drive real business results
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card 
                key={service.id}
                className="group hover:shadow-xl transition-all duration-300 border-gray-200 bg-gradient-to-br from-white to-orange-50 hover:-translate-y-1"
              >
                <CardHeader>
                  <div style={{ backgroundColor: '#D97904' }} className="w-14 h-14 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                    <IconComponent className="w-7 h-7 text-white" />
                  </div>
                  <CardTitle className="text-xl font-bold text-gray-900">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-gray-600 leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* CTA Section */}
        <div className="mt-16 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button
            asChild
            size="lg"
            data-testid="view-all-services-btn"
            className="text-white font-bold rounded-full px-8 py-6 text-base hover:opacity-90"
            style={{ backgroundColor: '#D97904' }}
          >
            <Link to="/services">
              View All Services &amp; Pricing <ArrowRight className="w-5 h-5 ml-2" />
            </Link>
          </Button>
          <Button
            asChild
            size="lg"
            variant="outline"
            data-testid="home-digital-card-link"
            className="rounded-full px-8 py-6 text-base border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white"
          >
            <a href={DIGITAL_CARD_URL} target="_blank" rel="noopener noreferrer">
              <CreditCard className="w-5 h-5 mr-2" /> Digital Business Card <ExternalLink className="w-4 h-4 ml-2" />
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Services;
